import pages from '../content/pages.json';

export interface StaticPage {
    path: string;
    /** WordPress post that holds the content */
    postId: number;
    title: string;
    /** for search engines and link previews */
    description: string;
    /** listed in the "Verein" menu */
    clubMenu?: boolean;
}

/** Defined in src/content/pages.json, which scripts/seo.mjs reads as well. */
export const STATIC_PAGES: StaticPage[] = pages.static;
